import { Avatar, Typography } from 'antd'

// Constant
import { ROOT_CONSTANT } from '../../../../constants'

// Styles
import cs from './index.module.css'

// Redux Actions
import { REDUX as REDUX_UTIL } from "../../../../services/util";
import { useSelector } from "react-redux";

const { reduxStoreWrapper } = REDUX_UTIL;
const { Text } = Typography;

const AvatarIcon = () => {
    const user = useSelector(reduxStoreWrapper("user"));
    const company = useSelector(reduxStoreWrapper("company.byCOID"));

    return (
        <>
            { user.uroleid === "A" ? (
                <Avatar className={cs.avatar} style={{ backgroundColor: '#4169E1', border: '1px solid #4169E1' }} size={40} src={ROOT_CONSTANT.THEME.LOGO}></Avatar>)
            : (
                <Avatar 
                    style={{ backgroundColor: '#F5FBFF', border: '1px solid #4169E1', display: 'flex', alignItems: 'center', justifyContent: 'center'  }}
                     size={40} >
                    <Text style={{ fontSize: '2rem', color: '#4169E1' }}>{user.name && user.name.trim().charAt(0).toUpperCase()}</Text>
                </Avatar>
            )}
        </>
    )
}

export default AvatarIcon